import StepProcessor, { Step } from '@lib/StepProcessor';

class SignDocumentsStepProcessor extends StepProcessor {
  getSteps() {
    return [
      new Step(
        'sign_commercial_contract',
        '/sign-documents/commercial-contract-summary',
        '/sign-documents/commercial-contract'
      ),
      new Step('sign_risk_form', '/sign-documents/accept-risk-form'),
      new Step('profile', '/perfil')
    ];
  }
}

export default SignDocumentsStepProcessor;
